import { Box, ColorOptions, convertHexToRGBA, ModBox, Spacer, Text } from '@jfs/ui-new'
import React, { useCallback, useState } from 'react'
import { FlatList } from 'react-native'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors } from '../../../../util/util'
import { AcessRightsCheckbox } from './AcessRightsCheckbox'
import { fieldCheckboxName } from './FormData'
import { ModelSelectUserRole } from './ModelSelectUserRole'

export interface LabeledComponentTypes {
  fieldName: string
  setFieldValue?: (fieldName: string, val: string | number) => void
  maxLength: number
  value?: string
  component: React.ElementType
  minWidth: number
  onChange: (value: string) => void
  editable: boolean
  placeHolder: any
  data: any
}

const CheckBoxFormData = ({
  accessRightsData,
  updateCheckedArray,
  expandView,
  setFieldValue,
  role,
  isEditScreen,
  allEditable,
}: any) => {
  const renderList = ({ item, index }: any) => {
    return (
      <AcessRightsCheckbox
        fieldName={`${fieldCheckboxName}_` + index}
        heading={item.type && item.type.toLowerCase() !== 'null' ? item.type : 'Miscellaneous'}
        initialCheckBoxData={item?.data}
        expandView={expandView}
        setFieldValue={(key, value) => setFieldValue(key, value)}
        onSelect={(val: any) => updateCheckedArray(index, val)}
        key={index}
        role={role}
        isEditScreen={isEditScreen}
        allEditable={allEditable}
      />
    )
    // return {
    //   fieldName: `${fieldCheckboxName}_` + index,
    //   ComponentName: AcessRightsCheckbox,
    //   heading: item.type && item.type.toLowerCase() !== 'null' ? item.type : 'Miscellaneous',
    //   initialCheckBoxData: item.data,
    //   updateCheckBoxData: () => { },
    //   expandView: false,
    //   onSelect: (val: any) => updateCheckedArray(index, val),
    // }
  }
  // console.log('accessRightsData flatlist', isEditScreen, accessRightsData)
  return <FlatList numColumns={2} renderItem={renderList} data={accessRightsData} />
}

export const DepartmentDropdown = ({
  checkedArray,
  onChange,
  onSelectAll,
  allValues,
  accessRightsData,
  updateCheckedArray,
  expandView = false,
  isEditScreen,
  setFieldValue,
  allEditable,
  ...props
}: any): React.ReactElement => {
  const isSelectedAll = useCallback(() => {
    return (
      checkedArray?.filter((item: any) => {
        return !item?.state
      }).length === 0
    )
  }, [checkedArray])

  const [role, setRole] = useState(props.value)
  const [show, setShow] = useState(false)
  const minWidth = props?.minWidth

  const updateSelectedRole = (clickedRole: string) => {
    setFieldValue?.(props.fieldName, clickedRole)
    setRole(clickedRole)
    onChange?.(clickedRole)
  }

  const SelectAllData = () => {
    onSelectAll(isSelectedAll(), role)
  }

  return (
    <Box
      flexDirection={'column'}
      borderWidth={1}
      ph={16}
      pv={20}
      borderRadius={8}
      borderColor={convertHexToRGBA(Colors.PRIMARY, 24) as ColorOptions}
      bg={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}>
      <ModBox
        show={!allValues?.role}
        justify={'space-between'}
        alignItems="center"
        flexDirection={'row'}
        underlayColor={'TRANSPARENT'}
        testID="select-role"
        onPress={() => setShow(true)}>
        <Box alignItems="center" flexDirection={'row'}>
          <SvgImage imageName="ManageUsersIcon" color={Colors.SECONDARY} />
          <Spacer size={10} direction="horizontal" />
          <Text fontSize={14} fontFamily={'JioType-Medium'} color={Colors.BLACK_14 as ColorOptions}>
            Select user role
          </Text>
        </Box>
        <SvgImage imageName="FaqArrowRight" color={Colors.PRIMARY} />
      </ModBox>

      <ModBox show={allValues?.role !== ''} justify={'space-between'} alignItems="center" flexDirection={'row'}>
        <Box alignItems="center" flexDirection={'row'}>
          <Box
            width={35}
            height={35}
            borderRadius={35}
            backgroundColor={'SECONDARY'}
            justify={'center'}
            alignItems="center">
            <SvgImage imageName="ProfileIconFilled" color={'#fff'} />
          </Box>
          <Spacer size={10} direction="horizontal" />
          <Box>
            <Text fontSize={12} fontFamily={'JioType-Medium'} color={Colors.PRIMARY_GREY}>
              User role
            </Text>
            <Text fontSize={16} fontFamily={'JioType-Bold'} color={Colors.BLACK_14 as ColorOptions}>
              {allValues.role}
            </Text>
          </Box>
        </Box>
        <ModBox
          show={!isEditScreen}
          underlayColor={'TRANSPARENT'}
          testID="change-role"
          onPress={() => {
            setShow(true)
          }}>
          <Text fontSize={14} fontFamily={'JioType-Medium'} color={'PRIMARY'}>
            Change
          </Text>
        </ModBox>
      </ModBox>

      <ModBox show={allValues.role !== ''}>
        <Spacer size={20} direction="vertical" />
        <Box width={'100%'} height={1} bg={'BLACK'} opacity={0.1} />
        <Spacer size={25} direction="vertical" />
        <ModBox show={allValues.role} flexDirection={'row'} justify="space-between" align="center">
          <Text fontSize={14} lineHeight={20} fontFamily={'JioType-Bold'} color={Colors.BLACK_14 as ColorOptions}>
            Permissions
          </Text>
          <ModBox
            show={allValues.role === 'Other'}
            underlayColor={'TRANSPARENT'}
            flexDirection={'row'}
            align="center"
            justify={'center'}
            testID="select-all-role"
            onPress={() => SelectAllData()}>
            <Text fontSize={12} fontFamily={'JioType-Medium'} color={'PRIMARY'}>
              {isSelectedAll() ? 'Deselect All' : 'Select All'}
            </Text>
          </ModBox>
        </ModBox>

        <Box flexDirection={'row'} mt={20}>
          <CheckBoxFormData
            accessRightsData={accessRightsData}
            updateCheckedArray={updateCheckedArray}
            expandView={expandView}
            setFieldValue={setFieldValue}
            role={role}
            isEditScreen={isEditScreen}
            allEditable={allEditable}
          />
        </Box>
      </ModBox>
      <ModelSelectUserRole
        show={show}
        data={props?.data}
        selectedValue={role}
        onDismiss={() => setShow(false)}
        setFieldValue={updateSelectedRole}
      />
    </Box>
  )
}
